import { dexQuery } from '@/helpers/graphql';
import {
  AssertionsByQuestionIdListType,
  CommentsByQuestionIdListType,
  ContentsType,
  RepliesByQuestionIdListType,
  SolutionsByQuestionId,
} from '@/models/undergrad/services/dex.services.model';
import { getObjectiveExerciseById } from '@/store/queries/dexQueries';

interface DexObjectiveExerciseType {
  contents: ContentsType[];
  alternatives: AssertionsByQuestionIdListType[];
  replies: RepliesByQuestionIdListType[];
  solutions: SolutionsByQuestionId[];
  comments: CommentsByQuestionIdListType[];
}

export class DexObjectiveExerciseService {
  static async getObjectiveExerciseById(
    id: number,
    userId: number,
  ): Promise<DexObjectiveExerciseType> {
    const exerciseId = parseInt(String(id), 10);
    const {
      data: {
        questionById: {
          repliesByQuestionIdList,
          contentsByQuestionIdList,
          assertionsByQuestionIdList,
          solutionsByQuestionIdList,
          commentsByQuestionIdList,
        },
      },
    } = await dexQuery(getObjectiveExerciseById, { questionId: exerciseId, userId });

    return {
      comments: commentsByQuestionIdList.map((c: any) => ({
        id: c.id,
        updatedAt: c.updatedAt,
        score: c.score,
        attemptCount: c.attemptCount,
        textId: c.contentsByCommentId.nodes[0].textId,
        content: c.contentsByCommentId.nodes[0].textByTextId.body,
      })),
      contents: (contentsByQuestionIdList as ContentsType[]).sort(
        (a, b) => a.position - b.position,
      ),
      alternatives: assertionsByQuestionIdList,
      replies: repliesByQuestionIdList,
      solutions: solutionsByQuestionIdList,
    };
  }
}
